import Skeleton from ".";
import Col from "../col";
import Row from "../row";

interface SkeletonTableProps {
  columns?: number;
  rows?: number;
  paging?: boolean;
  size?: "sm" | "md";
}

const skeletonHeight: Record<"sm" | "md", number> = {
  md: 48,
  sm: 40,
};

export default function SkeletonTable(props: Readonly<SkeletonTableProps>) {
  const { columns = 4, rows = 5, paging = true, size = "md" } = props;

  return (
    <Col gap="sm">
      <Row gap="md">
        {Array.from(Array(columns).keys()).map((i) => (
          <Skeleton key={i} height={skeletonHeight[size]} className="flex-1" />
        ))}
      </Row>
      {Array.from(Array(rows).keys()).map((i) => (
        <Skeleton key={i} height={skeletonHeight[size]} />
      ))}
      {paging && (
        <div className="flex justify-end">
          <Skeleton height={skeletonHeight[size]} className="w-96" />
        </div>
      )}
    </Col>
  );
}
